export const SUMMARY = 'summary';
export const EDUCATION_GOAL_TYPE = 'education';
export const LARGE_PURCHASE_GOAL_TYPE = 'largePurchase';
export const HOME_PURCHASE_GOAL_TYPE = 'homePurchase';
export const EMERGENCY_FUND_GOAL_TYPE = 'emergencyfund';
export const HEALTHCARE_GOAL_TYPE = 'healthCare';
export const DEBT_MANAGEMENT_GOAL_TYPE = 'debtmanagement';
